// extracted by mini-css-extract-plugin
module.exports = {"bid":"board-bid_bid__3yYzZ","title":"board-bid_title__2I-Q6","new-bid":"board-bid_new-bid__3Gwpw","amount-bid":"board-bid_amount-bid__3dA1l"};